import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  Select,
  MenuItem,
  IconButton,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/styles"
import React, { useEffect } from "react"
import { getMyGoalDetail, putUpdateProgressHistory, getMyGoalProgress, deleteProgressHistory } from "../../actions/mygoal"
import { useSelector, useDispatch } from "react-redux"

import CloseIcon from "../../assets/images/plus-circle-fill.svg"
import { ReactComponent as History } from "../../icons/history-2-black.svg"
import { ReactComponent as NoDataIcon } from "../../assets/icons/nodata.svg"
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg"
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg"
import WarningDialog from "../../components/WarningConfirm"
import SimpleDialog from "../../components/SimpleDialog"
import ConfirmDialog from "../../components/ConfirmDialog"
import ClearIcon from "@mui/icons-material/Clear"
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DesktopDatePicker } from '@mui/x-date-pickers';
// import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import moment from 'moment'

import * as Util from "../../services/global.service"

const HistoryDialog = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const language = localStorage.getItem("lang")
  const [isUpdateDialogOpen, openUpdateDialog] = React.useState(false)
  const [goalDetail, setGoalDetail] = React.useState(null)
  const [asOfDate, setAsOfDate] = React.useState(Util.formatDate(new Date()))
  const [targetValue, setTargetValue] = React.useState(null)
  const [serial, setSerial] = React.useState(null)
  const [scaleLevelCurrent, setScaleLevelCurrent] = React.useState(null)
  const [progressValue, setProgressValue] = React.useState(null)
  const [goalProgressOption, setGoalProgressOption] = React.useState([])
  const [remark, setRemark] = React.useState("")
  const [deleteSerial, setDeleteSerial] = React.useState("")
  const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false)
  const [isApproveDialogOpen, openApproveDialog] = React.useState(false)
  const [isConfirmEditOpen, openConfirmEditOpen] = React.useState(false)
  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false)
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false)

  const handleClose = () => {
    props.setValue(false)
    props.doCallback()
  }

  const handleCloseDialog = () => {
    openApproveDialog(true);
  }

  const handleConfirmApprove = () => {
    openApproveDialog(false);
    openUpdateDialog(false);
  }

  const handleConfirmApproveDialog = (val) => {
    openApproveDialog(val);
  }

  const handleClearClick = () => {
    setTargetValue(null)
  }

  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val)
  };

  const handleConfirmDeleteList = () => {
    openConfirmDeleteDialog(false)
    dispatch(deleteProgressHistory(deleteSerial))
      .then(resp => {
        if (resp.success) {
          openSuccessDeleteDialog(true)
          dispatch(getMyGoalDetail(props.serial, { member: 'no' }))
            .then(resp => {
              console.log(resp)
              setGoalDetail(resp.data)
              if (resp?.data?.log_goal_progress) {
                setHistoryData(resp.data.log_goal_progress)
              }
            })
        }
      })
  }

  const updateGoal = () => {
    openConfirmEditOpen(false);
    // Do API here /goals/${id}/progress

    let target = targetValue;
    if (targetValue && targetValue.indexOf('/') > 0) {
      var splitValue = target.split('/')
      target = splitValue[2] + "-" + splitValue[0] + "/" + splitValue[1]
    }

    const sendData = {
      serial: serial,
      actual_value: target,
      goal_progress_data: progressValue,
      remark: remark,
      date: asOfDate
    }

    dispatch(putUpdateProgressHistory(props.serial, sendData))
      .then((resp) => {
        if (resp.success) {
          openSuccessAddDialog(true);
          openUpdateDialog(false);
          dispatch(getMyGoalDetail(props.serial, { member: 'no' }))
            .then(resp => {
              setGoalDetail(resp.data)
              if (resp?.data?.log_goal_progress) {
                setHistoryData(resp.data.log_goal_progress)
              }
            })
        }
      })
  }

  const [historyData, setHistoryData] = React.useState({})
  const [historyOptionalData, setHistoryOptionalData] = React.useState({})
  const [targetCondition, setTargetCondition] = React.useState("")

  const testJSON = (strJson) => {
    try {
      const parsed = JSON.parse(strJson)
      if (parsed && typeof parsed === "object") {
        return true
      }
    } catch { return false }
    return false
  }

  const statusBox = (data, isCenter = false) => {
    if (data?.color && testJSON(data?.color)) {
      data.color = JSON.parse(data.color)
    }
    return (
      <Box style={{ backgroundColor: data?.color?.background ?? "#fff", width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', border: (data?.name_th === 'ยังไม่ได้ดำเนินการ' || data?.name_en === 'Not Started') ? '1px solid #DADADA4A' : `0px` }}>
        <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={data?.color?.font ?? "#404349"}>
          {Util.upperFirstWord(language === "en-US" ? data?.name_en ?? "-" : data?.name_th ?? "-")}
        </Typography>
      </Box>
    )
  }

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))

  const validateActualValueColor = (data) => {
    let result = false
    let targetCondition = ""
    if (historyOptionalData?.target_condition && historyOptionalData?.target_condition !== "") {
      targetCondition = historyOptionalData.target_condition.toLowerCase()
    }
    if (targetCondition !== "") {
      if (targetCondition === "equal") {
        if (parseFloat(historyOptionalData?.target_value) === parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "higher or equal to") {
        if (parseFloat(historyOptionalData?.target_value) <= parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "less or equal to") {
        if (parseFloat(historyOptionalData?.target_value) >= parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "higher") {
        if (parseFloat(historyOptionalData?.target_value) < parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "less") {
        if (parseFloat(historyOptionalData?.target_value) > parseFloat(data)) {
          result = true
        }
      }
    } else {
      if (historyOptionalData?.type === "accomplishment" || historyOptionalData?.type?.toLowerCase() === "ทำสำเร็จหรือไม่") {
        if (historyOptionalData?.target_value?.toLowerCase() === data?.toLowerCase()) {
          result = true
        }
        if (data?.toLowerCase() == 'fail') {
          result = false
        }
      } else if (historyOptionalData?.type === "date" || historyOptionalData?.type?.toLowerCase() === "ทำได้ภายใน End Date") {
        let targetValue = moment(String(historyOptionalData?.target_value), "DD-MM-YYYY")
        let actualValue = moment(String(data), "DD-MM-YYYY")
        let diff = targetValue.diff(actualValue, 'days')
        if (diff >= 0) {
          result = true
        }
      } else {
        if (historyOptionalData?.target_value >= data) {
          result = true
        }
      }
    }
    return result
  }

  const openEditPopup = (data) => {
    openUpdateDialog(true)
    setRemark(data?.remark)
    setSerial(data?.serial)
    setAsOfDate(Util.formatDate(data?.date ?? new Date))

    dispatch(getMyGoalDetail(props.serial, { member: 'no' }))
      .then(resp => {
        setGoalDetail(resp.data)
        if (resp.data.goal_progress?.goal_metric?.options?.type === 'date') {
          let dateSplit = data?.actual_value.split('/')
          let dateResult = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`
          setTargetValue(dateResult)
        } else {
          setTargetValue(data?.actual_value)
        }
        setTargetCondition(resp?.data?.goal_progress?.target_condition ?? "")
      })

    dispatch(getMyGoalProgress(props.serial))
      .then(resp => {
        if (resp.success) {
          setGoalProgressOption(resp.data.goal_progress_data)
          setScaleLevelCurrent(resp.data.goal_progress.scale_level_current)
          setProgressValue(resp.data.goal_progress_data?.find((item) => (item.name === data.name_en || item.name === data.name_th))?.serial)
        }
      })
  }

  const openDeleteConfirm = (data) => {
    openConfirmDeleteDialog(true)
    setDeleteSerial(data?.serial)
  }

  // useEffect
  useEffect(() => {
    if (props?.data.length > 0) {
      let data = props.data
      data.sort((a, b) => b.date.localeCompare(a.date) || b.created_at.localeCompare(a.created_at))
      setHistoryData(data)
    }
    if (props?.optionalData) {
      setHistoryOptionalData(props.optionalData)
    }
  }, [props.data, props.optionalData])

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="lg"
        fullWidth={true}
        PaperProps={{ sx: { p: 3 } }}
        aria-labelledby="history-dialog-title"
        aria-describedby="history-dialog-description"
      >
        <DialogTitle sx={{ m: 0, p: "0 0 12px 0" }}>
          <Box sx={{ display: "flex", justifyContent: "start", alignItems: "center", p: 0, m: 0, width: "100%" }}>
            <History />
            <Typography fontSize="24px" fontWeight="600" sx={{ ml: 1 }}>{t("corporateGoal.label.history")}</Typography>
            <Typography color='#404349' style={{ cursor: 'pointer' }} sx={{ ml: "auto" }} onClick={() => handleClose()}>
              X
            </Typography>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 0 }}>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            <Grid container my={1.5}>
              <Grid item xs="12" md="2" lg="2" xl="2">
                <Typography fontSize="18px" fontWeight="400" color="#A3A3A3">{t("corporateGoal.label.goalName")}</Typography>
              </Grid>
              <Grid item xs="12" md="10" lg="10" xl="10" style={{ wordBreak: 'break-word' }}>
                <Typography fontSize="18px" fontWeight="400" color="#404349">{historyOptionalData?.goal_name ?? "-"}</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs="12" md="12" lg="12" xl="12">
                <TableContainer>
                  <Table sx={{ width: "100%" }} aria-label="simple table">
                    <TableHead sx={{ borderBottom: "1px solid #e0e0e0", borderTop: "1px solid #e0e0e0", background: "#FAFAFA" }}>
                      <TableRow>
                        <TableCell align="left" display="flex" sx={{ width: "300px" }}>
                          <Typography
                            fontWeight={500}
                            fontSize={14}
                            lineHeight="24px"
                            color="#A0A0A0"
                            sx={{ display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.resultAsOf")}
                          </Typography>
                        </TableCell>
                        <TableCell align="left" display="flex" >
                          <Typography
                            fontWeight={500}
                            fontSize={14}
                            lineHeight="24px"
                            color="#A0A0A0"
                            sx={{ display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.actualValue")}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography
                            fontWeight={500}
                            fontSize={14}
                            lineHeight="24px"
                            color="#A0A0A0"
                            sx={{ display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.goalProgress")}
                          </Typography>
                        </TableCell>
                        <TableCell align="left" sx={{ width: "450px" }}>
                          <Typography
                            fontWeight={500}
                            fontSize={14}
                            lineHeight="24px"
                            color="#A0A0A0"
                            sx={{ display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.remark")}
                          </Typography>
                        </TableCell>
                        {(props?.isOwner) &&
                          <TableCell align="left" sx={{ width: "100px" }}>
                            <Typography
                              fontWeight={500}
                              fontSize={14}
                              lineHeight="24px"
                              color="#A0A0A0"
                              sx={{ display: "flex" }}
                              component={'span'}
                            >
                              {t("admin.label.action")}
                            </Typography>
                          </TableCell>
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyData.length > 0 ?
                        historyData.map(row =>
                        (<TableRow>
                          <TableCell align="left">
                            <Box display="flex">
                              <Box
                                display="flex"
                                alignItems="flex-start"
                                justifyContent="start"
                                sx={{ flexFlow: "column" }}
                              >
                                <Typography
                                  fontWeight="400"
                                  fontSize={16}
                                  color="#404349"
                                >
                                  {Util.dateDayFormatAdmin(row?.date) ?? "-"}
                                </Typography>
                                <Typography
                                  fontSize={12}
                                  color="#A3A3A3"
                                  fontWeight="400"
                                >
                                  {`${t("corporateGoal.label.updateOn")}: ${Util.dateDayFormatAdmin(row?.updated_at ? row?.updated_at : row?.created_at) ?? "-"} (${Util.timeFormat(row?.updated_at ? row?.updated_at : row?.created_at) ?? "-"})`}
                                </Typography>
                                <Typography
                                  fontSize={12}
                                  color="#A3A3A3"
                                  fontWeight="400"
                                >
                                  {`${t("corporateGoal.label.updateBy")}: ${row?.updated_by ? row?.updated_by?.fullname ?? "" : row?.created_by?.fullname ?? ""}`}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontSize={16} fontWeight={400} color={validateActualValueColor(row?.actual_value ?? "") ? "#5DA196" : "#CC6058"}>
                              {row?.actual_value ?? "-"}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontSize={16} color="#404349" fontWeight={400}>
                              {statusBox(row)}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontSize={16} color="#404349" fontWeight={400}>
                              {row?.remark ?? ""}
                            </Typography>
                          </TableCell>
                          {props?.isOwner && //props?.isOwner
                            <TableCell align="left">
                              <BootstrapTooltip title={t('mygoal.label.edit')} placement="top">
                                <EditIcon style={{ cursor: "pointer", marginRight: '10px' }} onClick={() => { openEditPopup(row) }} />
                              </BootstrapTooltip>
                              <BootstrapTooltip title={t('mygoal.label.delete')} placement="top">
                                <DeleteIcon style={{ cursor: "pointer" }} onClick={(e) => { openDeleteConfirm(row) }} />
                              </BootstrapTooltip>
                            </TableCell>
                          }
                        </TableRow>)
                        )
                        : (
                          <TableRow>
                            <TableCell colSpan={4} sx={{ borderBottom: "0!important" }}>
                              <Box
                                textAlign="center"
                                sx={{ fontWeight: 300, flexFlow: "column" }}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <NoDataIcon />
                                <Box>
                                  <Typography color="#A0A0A0">{t("label.nodata")}</Typography>
                                </Box>
                              </Box>
                            </TableCell>
                          </TableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {/* update goal progress dialog */}
      <Dialog onBackdropClick={() => { return false }} open={isUpdateDialogOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
        <DialogContent px={0} pb={0}>
          <Grid container direction="row">
            <Grid item lg={11}>
              <Typography fontSize={24} fontWeight="600" color="#404349">
                {t('mygoal.label.editGoal')}
              </Typography>
            </Grid>
            <Grid item lg={1} style={{ textAlign: 'right' }}>
              <Typography color='#404349' style={{ cursor: 'pointer', paddingTop: '8px' }} onClick={handleCloseDialog}>
                X
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={{ paddingTop: "20px" }} />
          <Grid container>
            <Grid item lg={4} mt={2}>
              <Typography fontSize={16} color="#939393">
                {t('mygoal.label.goalToUpdate')}
              </Typography>
            </Grid>
            <Grid item lg={8} mt={2}>
              <Typography color="primary">
                {goalDetail?.goal?.name}
              </Typography>
            </Grid>
            <Grid item lg={4} mt={2}>
              <Typography fontSize={16} color="#939393">
                {t('mygoal.label.goalMetric')}
              </Typography>
            </Grid>
            <Grid item lg={8} mt={2}>
              <Typography color="#404349">
                {goalDetail?.goal_progress?.goal_metric.description}
              </Typography>
            </Grid>
            <Grid item lg={4} mt={2}>
              <Typography fontSize={16} color="#939393">
                {t('mygoal.label.targetValue')}
              </Typography>
            </Grid>
            <Grid item lg={8} mt={2}>
              <Typography color="#404349">
                {Util.upperFirstWord(targetCondition ?? '')} {goalDetail?.goal_progress?.target_value} {goalDetail?.goal_progress?.unit && goalDetail?.goal_progress?.unit !== "-" ? goalDetail?.goal_progress?.unit : ""}
              </Typography>
            </Grid>
            <Grid item lg={4} mt={2} pt={'7px'}>
              <Typography style={{ fontSize: 16 }} color="#939393">
                {t('corporateGoal.label.resultAsOf')}:
              </Typography>
            </Grid>
            <Grid item lg={8} mt={2} color="#404349">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  format="dd/MM/yyyy"
                  value={asOfDate}
                  disabled
                  onChange={(newValue) => {
                    if (newValue) {
                      setAsOfDate(Util.formatDate(newValue))
                    } else {
                      setAsOfDate(null)
                    }
                  }}
                  style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: asOfDate ? '#CED4DA' : '#CC6058' }}
                  inputProps={{
                    placeholder: "As of date", sx: {
                      "&::placeholder": {
                        color: "#AAAAAA"
                      },
                      "&borderColor": {
                        color: '#CED4DA'
                      },
                      "color": '#404349'
                    }
                  }}
                  renderInput={(params) => <TextField {...params}
                    fullWidth
                    size="small"
                    sx={{ input: { backgroundColor: '#F3F3F3!important' } }}
                    style={{ color: '#404349' }}
                  />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item lg={4} mt={2} pt={'7px'}>
              <Typography style={{ fontSize: 16 }} color="#939393">
                {t('corporateGoal.label.actualValue')}:
              </Typography>
            </Grid>
            <Grid item lg={8} mt={2} color="#404349">
              {goalDetail?.goal_progress?.goal_metric?.options?.type === 'date'
                ?
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid container direction="row">
                    <Grid item lg={10}>
                      <DesktopDatePicker
                        format="dd/MM/yyyy"
                        value={targetValue}
                        onChange={(newValue) => {
                          if (newValue) {
                            setTargetValue(Util.formatDate(newValue));
                          } else {
                            setTargetValue(null)
                          }
                        }}
                        style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: targetValue ? '#CED4DA' : '#CC6058' }}
                        inputProps={{
                          placeholder: "Current Value", sx: {
                            "&::placeholder": {
                              color: "#AAAAAA"
                            },
                            "&borderColor": {
                              color: '#CED4DA'
                            },
                            "color": '#404349'
                          }
                        }}
                        renderInput={(params) => <TextField {...params}
                          fullWidth
                          size="small"
                          style={{ color: '#404349' }}
                        />}
                      />
                    </Grid>
                    <Grid item>
                      <IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginLeft: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>
                    </Grid>
                  </Grid>
                </LocalizationProvider>
                :
                (!goalDetail?.goal_progress?.goal_metric?.options)
                  ?
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      value={targetValue}
                      onChange={(val) => { setTargetValue(val.target.value) }}
                      renderValue={(selected) => {
                        if (selected === null || selected === "") {
                          return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>;
                        } else {
                          return <Typography color="#404349">{selected}</Typography>
                        }
                      }}
                      endAdornment={<IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginRight: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>}
                    >
                      <MenuItem value={""}>
                        <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>
                      </MenuItem>
                      <MenuItem value={"Success"}>Success</MenuItem>
                      <MenuItem value={"Fail"}>Fail</MenuItem>
                    </Select>
                  </FormControl>
                  :
                  <TextField
                    autoComplete='off'
                    style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={targetValue} onChange={(e) => setTargetValue(e.target.value.replace(/[^\d.]|\.(?=.*\.)/g, ''))} placeholder={t("corporateGoal.label.fillTheActualValue")} variant="outlined" size="small" fullWidth
                    InputProps={{
                      endAdornment: targetValue ? (
                        <IconButton onClick={handleClearClick}>
                          <ClearIcon />
                        </IconButton>
                      ) : undefined
                    }}
                  />

              }
              {
                scaleLevelCurrent &&
                <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="left" sx={{ textTransform: "uppercase", mt: 1 }}>
                  {scaleLevelCurrent}
                </Typography>
              }
            </Grid>
            {/* <Grid item lg={2}></Grid> */}
            <Grid item lg={4} mt={2} pt={'7px'}>
              <Typography style={{ fontSize: 16 }} color="#939393">
                {t('mygoal.label.goalProgress')}:
              </Typography>
            </Grid>
            <Grid item lg={8} mt={2}>
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  size="small"
                  value={progressValue}
                  onChange={(val) => { setProgressValue(val.target.value) }}
                  sx={{ color: "#404349" }}
                  renderValue={(selected) => {
                    if (selected === null) {
                      return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>Fill the goal progress</Typography>;
                    } else {
                      return goalProgressOption?.find((item) => item.serial === selected)?.name
                      // Mockup Because api is not working
                    }
                  }}
                >
                  <MenuItem disabled value={null}>
                    <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>Fill the goal progress</Typography>
                  </MenuItem>
                  {goalProgressOption?.map((item, key) => {
                    return <MenuItem key={key} value={item.serial} sx={{ color: "#404349" }}>{item.name}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={12} mt={2} pt={'7px'}>
              <Typography style={{ fontSize: 16 }} color="#939393">
                {t('corporateGoal.label.remark')}:
              </Typography>
            </Grid>
            <Grid item lg={12} pt={'7px'}>
              <TextField
                autoComplete='off'
                multiline
                rows={2}
                maxRows={4}
                style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder={`Fill the remark`} variant="outlined" size="small" fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Box classes="mt-3">
            <Button onClick={handleCloseDialog} color="black" variant="outlined" style={{ marginRight: '35px', paddingLeft: '48px', paddingRight: '48px', textTransform: 'none', borderColor: '#DADADA !important' }}>
              {t('mygoal.label.cancel')}
            </Button>
            <Button onClick={() => openConfirmEditOpen(true)} color="primary" variant="contained" style={{ paddingLeft: '48px', paddingRight: '48px', textTransform: 'none' }}>
              <Typography>
                {t('mygoal.label.save')}
              </Typography>
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title={`${t("mygoal.label.confirmDelete")}`} text={`${t("mygoal.label.confirmDeleteHisDesc")}`} cancel={t('mygoal.label.no')} confirm={t('mygoal.label.yes')} />
      <SimpleDialog open={isSuccessAddDialogOpen} setValue={openSuccessAddDialog} text={t('mygoal.popup.updateHistory')} title={t('mygoal.popup.success')} />
      <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={openSuccessDeleteDialog} title={t('mygoal.popup.success')} text={t('mygoal.popup.deleteGoalHisSuccess')} />
      <WarningDialog open={isApproveDialogOpen} doConfirm={handleConfirmApprove} setValue={handleConfirmApproveDialog} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
      <WarningDialog open={isConfirmEditOpen} doConfirm={() => updateGoal()} setValue={openConfirmEditOpen} title={t('mygoal.popup.confirmChange')} text={t('mygoal.popup.confirmChangeDesc2')} />
    </React.Fragment>
  );
};
export default HistoryDialog;
